import React from "react";
import {ModalComponent, ModalComponentProps} from 'module/Modal/component/ModalComponent';
import {useModal} from 'module/Modal/hook/useModal';
import {RequiredKeys} from 'util/types/KeyTypeUtil';

type MP = RequiredKeys<ModalComponentProps, 'modalKey'>
type ModalProps = MP | Omit<MP, 'open' | 'onClose'>

export const Modal = React.memo((props: ModalProps) => {
	const {open = false, position, size, onClose, onChangedPositionSize} = useModal(props.modalKey);

	return (
		<ModalComponent
			{...props}
			modalKey={props.modalKey}
			open={'open' in props ? props.open : open}
			defaultSize={size || props.defaultSize}
			defaultPosition={position || props.defaultPosition}
			onClose={'onClose' in props ? props.onClose : onClose}
			onChangedPositionSize={onChangedPositionSize}
		>
		</ModalComponent>
	)
})
